<div *ngIf="optionGroups.length" class="border-top pt-3 mt-3">
  <div
    *ngIf="showSelectedSummary"
    aria-label="Current configuration"
    class="mb-2"
  >
    <p *ngFor="let group of optionGroups" class="fw-semibold mb-1">
      {{ selectedSummary(group) }}
    </p>
    <p
      *ngIf="configurationUi.contextNote"
      class="small text-body-secondary mb-0"
    >
      {{ configurationUi.contextNote }}
    </p>
  </div>

  <details
    *ngIf="presentation === 'disclosure'; else expandedOptions"
    #optionsDisclosure
    (toggle)="onDisclosureToggle($event)"
  >
    <summary
      class="btn btn-link btn-sm fw-semibold px-0"
      [attr.aria-expanded]="optionsDisclosure.open"
    >
      {{ configurationUi.changeLabel }}
    </summary>

    <ng-container *ngTemplateOutlet="optionFields"></ng-container>
  </details>

  <ng-template #expandedOptions>
    <div aria-label="Platform configuration">
      <ng-container *ngTemplateOutlet="optionFields"></ng-container>
    </div>
  </ng-template>

  <ng-template #optionFields>
    <div class="pt-2">
      <fieldset
        *ngFor="let group of optionGroups; let first = first"
        class="pt-3"
        [class.border-top]="!first"
        [class.mt-3]="!first"
      >
        <legend class="h6 fw-bold mb-3">{{ group.legend }}</legend>

        <div *ngIf="group.input as input; else choiceOptions" class="mb-2">
          <label
            class="form-label fw-semibold"
            [for]="inputId(group.id, 'value')"
          >
            {{ input.label }}
          </label>
          <div class="input-group w-50">
            <input
              class="form-control"
              type="number"
              inputmode="decimal"
              [id]="inputId(group.id, 'value')"
              [name]="platformId + '-' + group.id"
              [min]="input.minimumBasisPoints / 100"
              [max]="input.maximumBasisPoints / 100"
              [step]="input.stepBasisPoints / 100"
              [value]="percentageValue(group)"
              (input)="updatePercentage(group, $event)"
            />
            <span class="input-group-text">%</span>
          </div>
          <p
            *ngIf="input.description"
            class="small text-body-secondary mt-2 mb-0"
          >
            {{ input.description }}
          </p>
        </div>

        <ng-template #choiceOptions>
          <div class="d-grid gap-2">
            <div
              *ngFor="let choice of group.choices ?? []"
              class="form-check border rounded-3 p-3 ps-5"
            >
              <input
                class="form-check-input"
                type="radio"
                [id]="inputId(group.id, choice.id)"
                [name]="platformId + '-' + group.id"
                [value]="choice.id"
                [checked]="selections[group.id] === choice.id"
                (change)="select(group.id, choice.id)"
              />
              <label
                class="form-check-label fw-semibold"
                [for]="inputId(group.id, choice.id)"
              >
                {{ choice.label }}
              </label>
              <p
                *ngIf="choice.description && selections[group.id] === choice.id"
                class="small text-body-secondary mt-2 mb-0"
              >
                {{ choice.description }}
              </p>
            </div>
          </div>
        </ng-template>
      </fieldset>
    </div>
  </ng-template>
</div>
